/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BodyData } from './BodyData';
import {
    BodyDataFromJSON,
    BodyDataFromJSONTyped,
    BodyDataToJSON,
} from './BodyData';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface BodyDataPagination
 */
export interface BodyDataPagination {
    /**
     * 
     * @type {Array<BodyData>}
     * @memberof BodyDataPagination
     */
    data?: Array<BodyData>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof BodyDataPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the BodyDataPagination interface.
 */
export function instanceOfBodyDataPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BodyDataPaginationFromJSON(json: any): BodyDataPagination {
    return BodyDataPaginationFromJSONTyped(json, false);
}

export function BodyDataPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): BodyDataPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(BodyDataFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function BodyDataPaginationToJSON(value?: BodyDataPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(BodyDataToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

